module.exports = "/packs/banner_sp_webdesigner-029dd092059f7c2ff803a77e5223211f.png";